module.exports = __webpack_public_path__ + "static/media/steering-stering-suspension-evaluation-red.9b317a7b.svg";